import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, ref,getCurrentInstance } from "vue";
import { useUserStore } from "@/store/userStore";
import FetchRequest from "@/api/FetchRequest";
import User from "@/mode/User";
import UserApi from "@/api/UserApi";
import AvatarUpload from "@/components/AvatarUpload.vue";
import { ElMessage } from "element-plus";
import { currentUser,updateUser } from "@/api/Login";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let { proxy } = getCurrentInstance()
const userStore = useUserStore();
const user = reactive<User>({
  id: "",
  nickname: "",
  // mobile: "",
  email: "",
  avatar: "",
  // deptId: "",
  sex: "",
});

/** 初始化用户 */
if (userStore.user) {
  currentUser().then((res) => {
    user.id = res.data.id;
    user.nickname = res.data.nickname;
    user.deptId = res.data.deptId;
    // user.mobile = res.data.mobile;
    user.email = res.data.email;
    user.avatar = res.data.avatar === "" ? null : res.data.avatar;
    user.sex = res.data.sex;
  });
}

/** 验证规则 */
const rules = ref({
  avatar: [{ required: true, message: "头像不能为空", trigger: "blur" }],
  name: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
  email: [
    { required: true, message: "邮箱地址不能为空", trigger: "blur" },
    {
      type: "email",
      message: "'请输入正确的邮箱地址",
      trigger: ["blur", "change"],
    },
  ],
  mobile: [
    { required: true, message: "手机号码不能为空", trigger: "blur" },
    {
      pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
      message: "请输入正确的手机号码",
      trigger: "blur",
    },
  ],
});

/** 上传成功 */
const uploadSuccess = (url: string) => {
  console.log(url)
  user.avatar = url;
};

/** 提交按钮 */
function submit() {
  updateUser(user)
    .then(() => {
      return  currentUser();
    })
    .then((res) => {
      userStore.setUser(res.data);
      userStore.storeUser(user.id, res.data);
      ElMessage.success("修改成功");
    });
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "userRef",
    model: user,
    rules: rules.value,
    "label-width": "80px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "头像",
        prop: "avatar",
        class: "avatar-box"
      }, {
        default: _withCtx(() => [
          _createVNode(AvatarUpload, {
            class: "avatar",
            avatar: user.avatar,
            onUploadSuccess: uploadSuccess
          }, null, 8, ["avatar"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "名称",
        prop: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: user.nickname,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.nickname) = $event)),
            maxlength: "30"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "邮箱",
        prop: "email"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: user.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.email) = $event)),
            maxlength: "50"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "性别" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: user.sex,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.sex) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, { label: "0" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("男")
                ])),
                _: 1
              }),
              _createVNode(_component_el_radio, { label: "1" }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("女")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("保存")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})